/* eslint-disable @typescript-eslint/no-explicit-any */
export const FIELD = 'field';
export const SECTION = 'section';

export type Form = (FormField | FormSection)[];

export interface VariableType {
  [key: string]: string;
}

export const VARIABLES_TYPE: VariableType = {
  franchise: 'division',
  country: 'branchId',
  account: 'accountId',
  surgeon: 'contactId',
  salesRep: 'salesRepId',
  primaryAccount: 'accountId',
};

export interface FunctionMap {
  [key: string]: Function;
}

export interface WorkflowPermission {
  workflowPermission: {
    id: string;
  } | null;
}

export interface FormEngineProps {
  division: string;
  formItems: Form;
  apiData: any;
  selectSalesRep?: any;
  useLazyQueryObject: FunctionMap;
  handleSave: (result: any) => void;
  toggleOpen: () => void;
  isOpen: boolean;
  createEventLoading?: boolean;
  createRequest?: boolean;
  showCSRFields?: WorkflowPermission | null;
  showSurgeonFields?: WorkflowPermission | null;
  formValues?: any;
  accountChecked?: any;
  selectedTab?: any;
  handleRadioButtonChange?: any;
  handleToggleButtonChange?: any;
  handleTabChange?: any;
  partsData?: any;
  locationChecked?: any;
  handleClickedButton?: (buttonType: string) => void;
  eventStatus?: string;
  showCreateInventoryButton?: WorkflowPermission | null;
  showCreateOpenButton?: WorkflowPermission | null;
  handleCancelButton?: () => void;
  handleCallback?: any;
  isEventInventoryButton?: boolean;
  handleUploadFiles?:
    | ((value: string, label: string) => Record<string, any> | undefined)
    | undefined;
  handleDeleteAttachments?: ((value: any, label: string) => any | undefined) | undefined;
  uploadedFiles?: File[];
  uploadedShippingLabelFiles?: File[];
  modalHeading?: string;
  handleAccountSelection?: any;
  handleRecievingRepSelection?: any;
  handleAccountIdSelection?: any;
  handleSalesRepSelection?: any;
  eventUsage?: any;
  warning?: boolean;
  partsIssue?: string;
  formType?: string;
  handleShippingToggleButton?: any;
  handleServiceLevelJustification?: any;
  isEdit?: any;
  isIR?: boolean;
  isUserOpsCsr?: boolean;
  type?: boolean;
  suppressShipToAutoSelect?: boolean;
}

export interface FormFieldOption {
  value?: string;
  name?: string;
  label: string;
  id?: string;
}

export interface File {
  id?: string;
  name: string;
  imageurl: string;
}

export interface FormField {
  kind: typeof FIELD;
  name: string;
  fieldLabel: string;
  fieldType: string;
  required: boolean;
  optionsStatic?: FormFieldOption[];
  optionsPlaceHolder?: string;
  optionsDynamic?: string;
  optionsDependentField?: string[];
  optionsDynamicDependent?: string;
  optionsAutoSelected: boolean;
  characterLimit?: number;
  showTooltip?: boolean;
  permissionSets?: string[];
  showOnWeb?: boolean;
  disabled?: boolean;
  showAddButton?: boolean;
  addButtonText?: string;
  keypadType?: 'number-pad' | 'default';
  minValue?: string;
  maxValue?: string;
  allowBackDate?: boolean;
  date?: boolean;
  isShow?: boolean;
  time?: boolean;
  fields?: string;
  isFailed?: boolean;
}

export interface ShipToAddress {
  address1?: string;
  address2?: string;
  city?: string;
  id?: string;
  isPrimaryAddress?: boolean;
  isPrimaryAccount?: boolean;
  name?: string;
  label?: string;
  value?: string;
  postalcode?: string;
  state?: string;
  __typename?: string;
}

export interface FormSection {
  kind: typeof SECTION;
  fields: FormField[];
}

export interface FormInitialValues {
  [key: string]: any;
}
